import { render, staticRenderFns } from "./QueryCreateMenuItem.vue?vue&type=template&id=b352933a&scoped=true"
import script from "./QueryCreateMenuItem.vue?vue&type=script&lang=ts"
export * from "./QueryCreateMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b352933a",
  null
  
)

export default component.exports